export { default as BulletinScreen } from "./BulletinScreen";
